import type { TAbout } from "@type/home";
import parse from "html-react-parser";
import Image from "next/image";

export const About = ({ image, title, description }: TAbout) => (
  <div className="relative px-2 py-4">
    <div className="mx-auto flex max-w-screen-xl flex-col lg:flex-row">
      <div className="m-auto w-full text-center lg:w-1/2">
        <Image
          alt={image?.sourceUrl}
          className="my-auto"
          height={320}
          src={image?.sourceUrl}
          width={570}
        />
      </div>
      <div className="mx-5 w-2 bg-gradient-to-b from-red to-orange" />
      <div className="w-full py-5 lg:w-1/2">
        <h3 className="text-4xl">{title}</h3>
        <br />
        <br />
        <div className="whitespace-pre-wrap">{parse(description || "")}</div>
      </div>
    </div>
  </div>
);
